import { Phone, MessageCircle, MapPin, Clock, Navigation } from "lucide-react";
import { business, telLink, waLink } from "@/config/business";
import { Reveal, Overline } from "@/components/Reveal";

export default function LocationSec() {
  return (
    <section id="contact" className="py-20 md:py-32 bg-soft" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <Reveal>
          <Overline>Visit Us</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl tracking-tight text-ink">
            Find Us in Paldi Meena
          </h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-2 gap-8 items-stretch">
          <Reveal>
            <div className="bg-white border border-primary/10 p-8 md:p-12 h-full flex flex-col">
              <h3 className="font-display text-3xl text-ink">{business.name}</h3>
              <ul className="mt-8 space-y-5 text-sm sm:text-base">
                <li className="flex items-start gap-4">
                  <MapPin size={20} className="text-accent shrink-0 mt-0.5" aria-hidden="true" />
                  <span className="text-ink">{business.address}</span>
                </li>
                <li className="flex items-start gap-4">
                  <Phone size={20} className="text-accent shrink-0 mt-0.5" aria-hidden="true" />
                  <a href={telLink} data-testid="location-phone-link" className="text-ink hover:text-primary transition-colors">
                    {business.phoneDisplay}
                  </a>
                </li>
                <li className="flex items-start gap-4">
                  <Clock size={20} className="text-accent shrink-0 mt-0.5" aria-hidden="true" />
                  <span className="text-ink">
                    {business.hours}
                    <span className="block text-[10px] uppercase tracking-widest text-accent font-semibold mt-1">
                      {business.verifyLabel}
                    </span>
                  </span>
                </li>
              </ul>

              <div className="mt-10 flex flex-wrap gap-3">
                <a
                  data-testid="location-call-button"
                  href={telLink}
                  className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3.5 text-sm font-semibold uppercase tracking-widest hover:bg-deep transition-colors min-h-[48px]"
                >
                  <Phone size={16} /> Call
                </a>
                <a
                  data-testid="location-whatsapp-button"
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-wa text-white px-6 py-3.5 text-sm font-semibold uppercase tracking-widest hover:opacity-90 transition-opacity min-h-[48px]"
                >
                  <MessageCircle size={16} /> WhatsApp
                </a>
                <a
                  data-testid="location-directions-button"
                  href={business.googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 border border-primary text-primary px-6 py-3.5 text-sm font-semibold uppercase tracking-widest hover:bg-primary hover:text-primary-foreground transition-colors min-h-[48px]"
                >
                  <Navigation size={16} /> Get Directions
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div
              data-testid="map-placeholder"
              className="relative h-full min-h-[360px] bg-deep flex flex-col items-center justify-center text-center p-10 border border-primary/10"
            >
              <MapPin size={40} className="text-accent" aria-hidden="true" />
              <p className="mt-5 font-display text-2xl text-cream max-w-xs">
                Google Maps embed will be placed here
              </p>
              <p className="mt-3 text-sm text-cream/60 max-w-sm">
                Paste the salon's Google Maps embed code before launch. Until then, use Get Directions.
              </p>
              <a
                data-testid="map-open-button"
                href={business.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 border border-accent text-accent px-6 py-3 text-sm font-semibold uppercase tracking-widest hover:bg-accent hover:text-deep transition-colors min-h-[48px]"
              >
                Open in Google Maps
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
